import * as React from 'react';
import Select from 'react-select';

const noop = () => {
    // no operation (do nothing real quick)
};

export default class SelectRequired extends React.Component {

    //state = {
    //    value: this.props.value || ""
    //};

    state = {
        selectedValue: this.props.value,
    };

    selectRef = null;
    setSelectRef = ref => {
        this.selectRef = ref;
    };

    //onChange = (value, actionMeta) => {
    //    this.props.onChange(value, actionMeta);
    //    this.setState({ value });
    //};

    onChange = (selectedValue, event) => {
        this.setState(
            { selectedValue },
            (() => { this.props.onChange(selectedValue, event) })
        );
    };

    getValue = () => {
        if (this.props.value != undefined) return this.props.value;
        return this.state.value || "";
    };

    getMultiValue = () => {
        //var optSplit = opciones.split(",");
        //var opcionesPostgrados = Array < any > ();
        //optSplit.map(opc => {
        //    var optionopc = OpcionesList.OportunidadesPostList.find(obj => obj.value === opc);
        //    opcionesPostgrados.push(optionopc);
        //});
        //this.setState({ opcionesOport: opcionesPostgrados });

        var valSplit = this.value.split
    }

    render() {
        const { SelectComponent, required, ...props } = this.props;
        const { isDisabled } = this.props;
        const enableRequired = !isDisabled;

        const customStyles = {
            container: (provided, state) => ({
                ...provided,
                height: "27px",
                position: "relative",
                flex: "1 1 auto",
                width: "inherit",
                minWidth: "0",
                marginBottom: "0",
            }),
            //indicatorsContainer: (provided, state) => ({
            //    ...provided,
            //    width: "0%",
            //    display: "none"
            //}),
            //indicatorSeparator: (provided, state) => ({
            //    ...provided,
            //    width: "0%",
            //    display: "none"
            //}),
            control: (provided, state) => {
                const backgroundColor = state.isDisabled ? "#e9ecef" : "#fff";
                return {
                    ...provided,
                    minHeight: '30px',
                    width: 'inherit',
                    height: '30px',
                    fontSize: 'small',
                    alignContent: 'center',
                    borderRadius: '0.1rem',
                    backgroundColor
                }
            },
            option: (provided, state) => {
                return {
                    ...provided,
                    fontSize: 'small',
                }
            },
        };
        //SelectComponent
        return (
            <div>
                <Select
                    {...props}

                    value={(this.props.isMulti ? this.props.value : this.props.options.find(obj => obj.value === this.props.value))}

                    onChange={this.onChange}
                    styles={customStyles}

                    isDisabled={this.props.isDisabled}
                    isMulti={this.props.isMulti}
                />
                <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{
                        opacity: 0,
                        width: "100%",
                        height: 0,
                        position: "absolute"
                    }}
                    value={this.getValue()}
                    required={required}
                    disabled={isDisabled}
                />
            </div>
        );
    }
}

SelectRequired.defaultProps = {
    onChange: noop
};

// value={(this.props.value ? this.props.options.find(obj => obj.value === this.props.value) : null)}

